export const BATCH_INTENTS = [
    "draft",
    "started",
    "paused",
    "cancelled",
];
export const SINGLE_TITLE_PRIORITY = 10;
export const BATCH_ITEM_PRIORITY = 1;
export const MINUTES_PER_TITLE = 15;
export function estimateBatchMinutes(remainingItems) {
    return Math.max(0, Math.trunc(remainingItems)) * MINUTES_PER_TITLE;
}
export function formatBatchEta(minutes) {
    if (minutes <= 0)
        return "—";
    if (minutes < 90)
        return `${minutes} min`;
    const hours = minutes / 60;
    if (hours < 36)
        return `${Math.round(hours)} h`;
    return `${Math.round(hours / 24)} days`;
}
const TERMINAL = ["completed", "failed"];
export function batchRollup(intent, items) {
    const total = items.length;
    const blocked = items.filter((i) => i.blocked).length;
    const startable = items.filter((i) => !i.blocked);
    const waiting = startable.filter((i) => i.phase === null).length;
    const completed = startable.filter((i) => i.phase === "completed").length;
    const failed = startable.filter((i) => i.phase === "failed").length;
    const running = startable.filter((i) => i.phase !== null && !TERMINAL.includes(i.phase)).length;
    const remaining = waiting + running;
    const status = (() => {
        if (intent === "cancelled")
            return "cancelled";
        if (total === 0)
            return "empty";
        if (startable.length === 0)
            return "all_blocked";
        if (intent === "draft")
            return "draft";
        if (intent === "paused")
            return "paused";
        if (remaining > 0)
            return "running";
        return failed > 0 ? "partly_failed" : "completed";
    })();
    return {
        status,
        total,
        blocked,
        waiting,
        running,
        completed,
        failed,
        remaining,
        etaMinutes: estimateBatchMinutes(remaining),
    };
}
export function batchStoragePrefix(batchId) {
    return `batches/${batchId}/`;
}
export function isSafeBatchPath(path) {
    if (typeof path !== "string")
        return false;
    const value = path.trim();
    if (value === "" || value.length > 400)
        return false;
    if (value.startsWith("/") || value.includes("\\"))
        return false;
    if (value.includes("//"))
        return false;
    if (/[\u0000-\u001f\u007f]/.test(value))
        return false;
    return !value
        .split("/")
        .some((seg) => seg === "" || seg === "." || seg === "..");
}
